export function getParentId(pathname: string): string {
  const pathnameArray = pathname.split('/');
  const pathNameLastItem = pathnameArray[pathnameArray.length - 1];
  return pathNameLastItem === 'welcome' ? 'root' : pathNameLastItem;
}

export function getIsInWelcomeScreen(pathname: string): boolean {
  const pathnameArray = pathname.split('/');
  return pathnameArray[pathnameArray.length - 1] === 'welcome';
}

export function getMode(role: string, welcomeScreenSelection?: string): string | undefined {
  const currentUserIsAdminOrPro = role === 'admin' || role === 'pro';
  return currentUserIsAdminOrPro ? welcomeScreenSelection : 'folder';
}

export function getHeadline(role: string, welcomeScreenSelection?: string): string {
  const mode = getMode(role, welcomeScreenSelection);
  return mode !== undefined ? `Create new ${mode}` : 'Create new';
}

export function validateTitleField(titleFieldValue: string): string | false {
  if (titleFieldValue.trim().length >= 3) {
    return titleFieldValue.length < 50 ? false : "Title can't be over 50 characters";
  }
  return 'Title must be at least 3 characters';
}
